export default __webpack_public_path__ + "static/media/facebook.ef824524.svg";